export default __webpack_public_path__ + "static/media/Celerio.432d374a.png";